import { combineReducers } from "@reduxjs/toolkit";
import { apiSlice, loginSlice } from "../services/http";

import {
  dialogModalReducer,
  isLoadingReducer,
} from "./slices/shared";

import confirmationAlertReducer from "../hook/confirmation-alert";

import {
  filterAccountingAccountReducer,
  filterAnalystAssignmentReducer,
  filterBalanceReportReducer,
  filterConciliationEmailsReducer,
  filterDivergenceListReducer,
  filterDivergenceRecordedReducer,
  filterEvidenceRegisterReducer,
  filterJustificationReducer,
  filterLackOfReconciliationReducer,
  filterLateConciliationReducer,
  filterNsuRegisterReducer,
  filterStoreEmailReducer,
  filterStoresReducer,
  filterDepositStoresReducer,
  filterDepositBatchesReducer,
  manageLossFilterReducer,
  statusConciliationReducer,
} from "./slices/conciliation";

import {
  editNcmSliceReducer,
  exceptionItemSliceReducer,
  extractorPdfIcmsReducer,
  filterAccessRequestReducer,
  filterEngineHistoryReducer,
  filterEngineRulesSliceReducer,
  filterExceptionListSliceReducer,
  filtersExceptionExportReducer,
  filtersGnreReducer,
  filtersHistoryEngineReducer,
  filtersNffReducer,
  filtersSpedReducer,
  filterSupplierSliceReducer,
  filterTaxesSliceReducer,
  filterTaxSliceReducer,
  gnreReducer,
  icmsListReducer,
  ncmFormSliceReducer,
  ofmFiltersReducer,
  spedDevolutionReducer,
  spedReducer,
  stepExceptionTaxSliceReducer,
  taxWorkflowFilterReducer,
} from "./slices/tax";

import {
  filterCashBalanceRecordSliceReducer,
  filtersTransactionReversalMadeReducer,
  filtersTransactionReversalReducer,
  filterTermValidationReducer,
  regionalSubstitutionFilterReducer,
  storeAccessFilterReducer,
} from "./slices/financial";

import { cavOfflineSyncFilterReducer } from "./slices/it";

import { campaignRouletteFilterReducer, gamificationFilterReducer, campaignFilterReducer } from "./slices/crm";

import {
  campaignFilterReducer as businessPlanningCampaignFilterReducer,
  overviewFilterReducer,
  selecaoFilterReducer,
  drillFilterReducer,
} from "./slices/businessPlanning";

import { sectorEmailsFilterReducer } from "./slices/rh";

import { filterUserReducer } from "./slices/users";

import {
  balanceReducer,
  filterAccessRequestStoreBackOfficeReducer,
  filterGenerateTermReducer,
  filterRegionalReducer,
} from "./slices/storeBackOffice";

import {
  priceRemarkFilterReducer,
  priceRemarkPendingFilterReducer,
} from "./slices/priceRemark";

export const rootReducer = combineReducers({

  [apiSlice.reducerPath]: apiSlice.reducer,
  [loginSlice.reducerPath]: loginSlice.reducer,

  isLoading: isLoadingReducer,
  dialogModal: dialogModalReducer,
  confirmationAlert: confirmationAlertReducer,

  filterAnalystAssignment: filterAnalystAssignmentReducer,
  filterJustification: filterJustificationReducer,
  filterAccountingAccount: filterAccountingAccountReducer,
  filterStores: filterStoresReducer,
  filterDepositStores: filterDepositStoresReducer,
  filterDepositBatches: filterDepositBatchesReducer,
  filterStoreEmail: filterStoreEmailReducer,
  filterConciliationEmails: filterConciliationEmailsReducer,
  filterLateConciliation: filterLateConciliationReducer,
  filterDivergenceList: filterDivergenceListReducer,
  filterDivergenceRecorded: filterDivergenceRecordedReducer,
  filterLackOfReconciliation: filterLackOfReconciliationReducer,
  filterBalanceReport: filterBalanceReportReducer,
  filterEvidenceRegister: filterEvidenceRegisterReducer,
  filterNsuRegister: filterNsuRegisterReducer,
  statusConciliation: statusConciliationReducer,
  manageLossFilter: manageLossFilterReducer,

  filterAccessRequest: filterAccessRequestReducer,
  ncmForm: ncmFormSliceReducer,
  editNCM: editNcmSliceReducer,
  filters: filtersGnreReducer,
  gnre: gnreReducer,
  filtersStateNFF: filtersNffReducer,
  filterTaxesState: filterTaxesSliceReducer,
  filterSped: filtersSpedReducer,
  sped: spedReducer,
  spedDevolution: spedDevolutionReducer,
  filterEngineRules: filterEngineRulesSliceReducer,
  icmsList: icmsListReducer,
  filterEngineHistory: filterEngineHistoryReducer,
  filtersSliceHistoryEngine: filtersHistoryEngineReducer,
  filterExceptionList: filterExceptionListSliceReducer,
  filtersStateExceptionExport: filtersExceptionExportReducer,
  exceptionItem: exceptionItemSliceReducer,
  stepExceptionTaxState: stepExceptionTaxSliceReducer,
  filterSupplier: filterSupplierSliceReducer,
  filterTax: filterTaxSliceReducer,
  ofmFilters: ofmFiltersReducer,
  extractorPdfIcms: extractorPdfIcmsReducer,
  taxWorkflowFilter: taxWorkflowFilterReducer,

  filterRecordCashBalance: filterCashBalanceRecordSliceReducer,
  filtersTransactionReversal: filtersTransactionReversalReducer,
  filtersTransactionReversalMade: filtersTransactionReversalMadeReducer,
  storeAccessFilter: storeAccessFilterReducer,
  filterStateTermValidation: filterTermValidationReducer,
  regionalSubstitutionFilter: regionalSubstitutionFilterReducer,

  cavOfflineSyncFilter: cavOfflineSyncFilterReducer,

  campaignRouletteFilter: campaignRouletteFilterReducer,
  GamificationFilter: gamificationFilterReducer,
  campaignFilter: campaignFilterReducer,
  businessPlanningCampaignFilter: businessPlanningCampaignFilterReducer,
  overviewFilter: overviewFilterReducer,
  selecaoFilter: selecaoFilterReducer,
  drillFilter: drillFilterReducer,

  sectorEmailsFilter: sectorEmailsFilterReducer,

  filterUser: filterUserReducer,

  filterStateAccessRequestStoreBackOffice: filterAccessRequestStoreBackOfficeReducer,
  filterStateRegional: filterRegionalReducer,
  balance: balanceReducer,
  filterStateGenerateTerm: filterGenerateTermReducer,
  priceRemarkFilter: priceRemarkFilterReducer,
  priceRemarkPendingFilter: priceRemarkPendingFilterReducer,
});

export type RootReducerState = ReturnType<typeof rootReducer>;
